import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import Signup from './Signup'
import styles from '../_auth.css'
import * as authActions from 'services/auth/actions'
import { selectLocation } from 'services/routing/selectors'
import { selectAppConfig } from 'services/bootup/selectors'
import { goToNext } from 'shared/routes'

const mapStateToProps = (state) => ({
  appConfig: selectAppConfig(state),
  location: selectLocation(state),
})

const mapDispatchToActions = {
  ...authActions,
  push,
}

export class SignupPage extends Component {

  static propTypes = {
    appConfig: PropTypes.object,
    push: PropTypes.func,
    dispatch: PropTypes.func,
    location: PropTypes.shape({
      search: PropTypes.string,
      query: PropTypes.object,
    }),
  }

  handleClickLogin = () => {
    const { location: { search }} = this.props
    this.props.push({ pathname: '/auth/login', search })
  }

  handleSignupSuccess = () => {
    const { newUserOnboarding } = this.props.appConfig
    const next = this.props.location.query.next
    goToNext(next, newUserOnboarding)
  }

  handleFacebookLoginSuccess = () => {
    const { newUserOnboarding } = this.props.appConfig
    const next = this.props.location.query.next
    goToNext(next, newUserOnboarding)
  }

  handleSignupConsents = () => {
    const { location: { search }} = this.props
    this.props.push({
      pathname: '/privacy_center/consents',
      search,
    })
  }

  render () {
    return (
      <div className={styles.container}>
        <Signup
          onClickLogin={this.handleClickLogin}
          onSignupSuccess={this.handleSignupSuccess}
          onFacebookLoginSuccess={this.handleFacebookLoginSuccess}
          onSignupConsents={this.handleSignupConsents}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(SignupPage)
